<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode='primary' :text="$t('notificationFilter.new_document')" icon='plus' @click='toggleNewDocument' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
      <p-d-f-viewer-dialog
        :dialogOpen="showModalPDF"
        :idAdjunto="idAdjuntoSelected"
        @toggleDialog="toggleDialogPdf" 
        />
      <input-select-dialog 
        header="Seleccionar tipo de documento"
        headerValue="Tipo de documento"
        :dialogOpen="showEditTipoDocumento" 
        :values="tiposDocumentosAeat"
        @toggleDialog="toggleEditTipoDocumento" 
        @applyDialog="editTipoDocumentoHandler"
        />
      <maestro-documentos-new-document-dialog 
        :dialogOpen="showNewDocument" 
        :valuesTipoDocumento="tiposDocumentosAeat"
        @toggleDialog="toggleNewDocument" 
        @applyDialog="applyNewDocument"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/MaestroDocumentosFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import InputSelectDialog from '@/components/InputSelectDialog.vue'
import { process } from '@progress/kendo-data-query'
import { i18n } from '@/i18n'
import { TIPOS_DOCUMENTOS_AEAT } from '@/config/tipos-documentos-aeat'

import { getMaestroDocumentosPag } from '@/services/notifications/getMaestroDocumentosPag'
import { getMaestroDocumentosExcel } from '@/services/notifications/getMaestroDocumentosExcel'

import { deleteMaestroDocumento } from '@/services/notifications/deleteMaestroDocumento'
import { editMaestroDocumento } from '@/services/notifications/editMaestroDocumento'
import { downloadMaestroDocumento } from '@/services/notifications/downloadMaestroDocumento'
import { uploadMaestroDocumento } from '@/services/notifications/uploadMaestroDocumento'
import PDFViewerDialog from '../../components/pdf/PDFViewerDialog.vue'
import MaestroDocumentosNewDocumentDialog from '../../components/MaestroDocumentosNewDocumentDialog.vue'

export default {
  name: 'vista-maestro-documentos',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    PDFViewerDialog,
    InputSelectDialog,
    MaestroDocumentosNewDocumentDialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 84,

      // Links
      isLoadedData: false,

      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,

      // All
      showModalPDF: false,
      showModalUpload: false,
      showNewDocument: false,
      showEditTipoDocumento: false,
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('documentmaster.documentmaster'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'documentmaster',
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
      tiposDocumentosAeat: TIPOS_DOCUMENTOS_AEAT,
      listaAcciones: [
        { IdAccion: 100, Descripcion: i18n.t('documentmaster.visualize') },
        { IdAccion: 200, Descripcion: i18n.t('documentmaster.edit') },
        { IdAccion: 300, Descripcion: i18n.t('documentmaster.download') },
        { IdAccion: 400, Descripcion: i18n.t('documentmaster.delete') },
      ],
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isMoreActionsVisible: function () {
      return this.getAccionesPosibles !== undefined && this.getAccionesPosibles.length > 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    selectIcon: function (action) {
      return (action) =>
        action === 100 ? 'eye'
          : action === 200 ? 'editpencil'
            : action === 300 ? 'download'
              : 'trash'
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      // Al seleccionar:
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Si es más de 1 solo cancelar. No permitimos descargas más de 1
        if (this.selected.length > 1) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion === 400)
        } else {
          if (this.selected[0].Extension.toUpperCase() !== 'PDF') {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 100)
          }
        }
      }
      return listaAccionesFinal
    },
    idAdjuntoSelected () {
      if (!this.selected || this.selected.length !== 1) return -1
      return this.selected[0].idAdjunto
    }
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
    },
    headerCoreFilters: {
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    toggleEditTipoDocumento (row) {
      this.showEditTipoDocumento = !this.showEditTipoDocumento
    },
    toggleNewDocument () {
      this.showNewDocument = !this.showNewDocument
    },
    toggleDialogPdf () {
      this.showModalPDF = !this.showModalPDF
    },
    toggleModalUpload () {
      this.showModalUpload = !this.showModalUpload
    },
    applyNewDocument: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { 
          codigoTipoDocumento: form.tipoDocumento,
          idCIFEmpresa: form.idCIFEmpresa,
          idCliente: form.idCliente,
        }
        const response = await uploadMaestroDocumento(file, params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.toggleNewDocument() 
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadAdjunto: async function (idAdjunto) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idAdjunto: idAdjunto
        }
        const response = await downloadMaestroDocumento(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          const fileName = this.selected[0].Documento + '.' + this.selected[0].Extension
          this.downloadBlob(response, fileName)
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    editTipoDocumentoHandler: async function (codigoTipoDocumento) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          codigoTipoDocumento: codigoTipoDocumento,
          idAdjunto: this.idAdjuntoSelected
        }
        const response = await editMaestroDocumento(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.toggleEditTipoDocumento()
          this.data = await this.applyFilters()
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
      // Old sin fix
      // this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Documento: data.Documento ? data.Documento.value : null,
        Extension: data.Extension ? data.Extension.value : null,
        CodigoTipoDocumento: data.CodigoTipoDocumento ? data.CodigoTipoDocumento.value : null,
        DescripcionTipoDocumento: data.DescripcionTipoDocumento ? data.DescripcionTipoDocumento.value : null,
        empresa: data.empresa ? data.empresa.value : null,
        distribuidor: data.distribuidor ? data.distribuidor.value : null,
        cif: data.cif ? data.cif.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.idImportacion)
          payload.listaIDs = selectedIDs
        }
        const response = await getMaestroDocumentosExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'maestro-documentos.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      this.filterByParamsData()
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Documento: data.Documento ? data.Documento.value : null,
        Extension: data.Extension ? data.Extension.value : null,
        CodigoTipoDocumento: data.CodigoTipoDocumento ? data.CodigoTipoDocumento.value : null,
        DescripcionTipoDocumento: data.DescripcionTipoDocumento ? data.DescripcionTipoDocumento.value : null,
        empresa: data.empresa ? data.empresa.value : null,
        distribuidor: data.distribuidor ? data.distribuidor.value : null,
        cif: data.cif ? data.cif.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getMaestroDocumentosPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 100) { // visualize
        this.toggleDialogPdf()
      } else if (this.selectedAction.IdAccion === 200) { // edit
        this.toggleEditTipoDocumento()
      } else if (this.selectedAction.IdAccion === 300) { // download
        this.downloadAdjunto(this.idAdjuntoSelected)
      } else if (this.selectedAction.IdAccion === 400) { // delete
        this.deleteMaestroDocumento()
      } else {
        console.error('Acción desconocida')
      }
    },
    deleteMaestroDocumento: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idAdjuntos: []
        }
        for (const element of this.selected) {
          payload.idAdjuntos.push(element.idAdjunto)
        }
        const response = await deleteMaestroDocumento(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    downloadExcelHandler: async function (apiCall) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await apiCall({ idImportacion: this.selected[0].idImportacion })
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = response.headers.filename
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.log(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
